var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { create } from 'zustand';
import { FlowReturnMethodStep } from '../constants';
import { getNextStep, getPreviousStep, getStep } from '../utils/general';
export var useFlowStore = create()(function () { return ({
    returnFlow: FlowReturnMethodStep,
}); });
export var goToStep = function (step) {
    return useFlowStore.setState({ returnFlow: getStep(step) });
};
export var goToNextStep = function (currentStep, returnMethod) {
    return useFlowStore.setState({ returnFlow: getNextStep(currentStep, returnMethod) });
};
export var goToPreviousStep = function (currentStep, returnMethod) {
    return useFlowStore.setState({
        returnFlow: getPreviousStep(currentStep, returnMethod),
    });
};
export var _mockFlowStore = function (mockedState) {
    return useFlowStore.setState(function (state) { return (__assign(__assign({}, state), mockedState)); });
};
